import React from "react";
import "./LeadershipModel.css";
import leadershipImage from "../../Assets/images/model.png";

const LeadershipModel = () => {

  return (
    <section className="leadership-model">

      <div className="leadership-content">

        <h2 className="section-title">
          The Ample Leadership Model
        </h2>

        <p className="section-intro">
          A clear path from personal growth to collective impact.
        </p>

        <p className="section-intro">
          Leadership at Ample House is built through a structured cycle:
        </p>

        <div className="stages">

          <div className="stage-card">

            <div className="stage-icon">📚</div>

            <h3>Edu-Care</h3>

            <p>
              Awareness and mastery
            </p>

          </div>

          <div className="stage-card">

            <div className="stage-icon">⚡</div>

            <h3>Power</h3>

            <p>
              Application and execution
            </p>

          </div>

          <div className="stage-card">

            <div className="stage-icon">🤝</div>

            <h3>Communi-Care</h3>

            <p>
              Collaboration and experience
            </p>

          </div>

        </div>

        <p className="closing-line">
          Lead Self. Lead Others. Lead Systems.
        </p>

      </div>

      <div className="leadership-image">

        <div className="leadership-image-wrapper">

          <img
            src={leadershipImage}
            alt="Leadership Model Illustration"
          />

        </div>

      </div>

    </section>
  );
};

export default LeadershipModel;